module.exports = __webpack_public_path__ + "img/spanish.56421e72.svg";